var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { MotionConfig } from 'framer-motion';
import { AudioPlayerProvider } from 'hx-audio-player';
import { AppRoutes, Sentry } from 'hx-util';
import 'iframe-resizer';
import { IconContext } from 'react-icons';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider as StoreProvider } from 'react-redux';
import { useMount } from 'react-use';
import { HistoryRouter } from 'redux-first-history/rr6';
import { ProgressProvider } from 'hx-progress';
import { phases } from '@/constants/phases.constant';
import { history, store } from '@/store';
import { appRoutes } from '@/App.routes';
import { DinPlayer } from '@/components/din-player.component';
import { iconConfig, theme } from '@/theme/theme';
import { useEvents } from '@/events/hooks/use-legato-event.hook';
var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            suspense: true,
            staleTime: Infinity,
        },
    },
});
export function App() {
    useEvents();
    useMount(function () {
        window.top.postMessage({ type: 'host/ready' }, '*');
    });
    return (_jsx(HistoryRouter, __assign({ history: history }, { children: _jsx(Sentry, { children: _jsx(QueryClientProvider, __assign({ client: queryClient }, { children: _jsxs(ThemeProvider, __assign({ theme: theme }, { children: [_jsx(CssBaseline, {}), _jsx(IconContext.Provider, __assign({ value: iconConfig }, { children: _jsx(MotionConfig, __assign({ reducedMotion: "user" }, { children: _jsx(StoreProvider, __assign({ store: store }, { children: _jsx(AudioPlayerProvider, { children: _jsx(DinPlayer, { children: _jsx(ProgressProvider, __assign({ phases: phases }, { children: _jsx(AppRoutes, { routes: appRoutes, fallback: _jsx("div", __assign({ className: "grid min-h-widget place-items-center" }, { children: _jsx(CircularProgress, {}) })) }) })) }) }) })) })) }))] })) })) }) })));
}
export default App;
